import TicketType from './TicketTypes';
import TicketTypeProvider from './TicketTypesContext';

let Index = () => {
    return (
        <TicketTypeProvider>
            <TicketType />
        </TicketTypeProvider>
    )
}

export default Index;